export default __webpack_public_path__ + "static/media/86dd6a_8c79b1538eca48c295aacf3a775d1ff2~mv2.35c169a7.gif";